/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaInputCurrency/view.blocks to change it.
import React from 'react'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaInputCurrency({
  children,
  viewPath = "/DesignSystem/TysiaInput/TysiaInputCurrency",
  autoFocus,
  type,
  placeholder,
  onChange,
  onBlur,
  onFocus,
  onKeyUp,
  value,
  disabled,
  onSubmit,
  innerRef
  
}) {
  return (<React.Fragment
>
<TysiaInputFieldMasked
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 autoFocus={autoFocus}
 type={type}
 placeholder={placeholder}
 onChange={onChange}
 onBlur={onBlur}
 onFocus={onFocus}
 onKeyUp={onKeyUp}
 value={value}
 disabled={disabled}
 onSubmit={onSubmit}
 innerRef={innerRef}
 mask="currency"
/>
{children}
</React.Fragment>)
}